var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533 4832 c-154 -55 -253 -186 -261 -347 -4 -77 5 -114 227 -1002 l231 -923 -231 -922 c-222 -889 -231 -926 -227 -1003 3 -59 11 -95 31 -138 34 -74 119 -160 194 -195 52 -24 70 -27 165 -27 l108 0 1956 978 c2153 1077 2022 1005 2087 1136 30 61 32 72 32 171 0 99 -2 110 -32 171 -65 131 66 59 -2086 1136 l-1955 977 -94 3 c-71 3 -105 -1 -145 -15z m2067 -1262 c1675 -838 1920 -963 1926 -985 17 -68 142 -1 -1926 -1035 -1056 -528 -1931 -960 -1945 -960 -32 0 -65 33 -65 65 0 19 353 1451 421 1708 l10 37 876 0 c866 0 877 0 919 21 117 56 117 222 0 278 -42 21 -53 21 -919 21 l-876 0 -10 38 c-68 256 -421 1688 -421 1707 0 32 33 65 65 65 14 0 889 -432 1945 -960z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.283a6ace902461c961d36da3b5349352.svg";
export { ForwardRef as ReactComponent };